import * as React from "react";
import {connect} from 'react-redux';
import * as selectors from "../../selectors";
import {DisplayFeature, SidePositionEdit} from "../../domain";
import {UpdateSidePositions, updateSidePositions} from "../../../../actions/actions";
import classNames = require("classnames");
import FeaturesState from "../../domain/FeaturesState";
import {
    getSidePositionRelativeToMeteringDirection,
    createSidePositionEdit,
    getSidePositionForFeatureRelativeToMeteringDirection,
    sidePositionFromDomain, getSidePositionsNorwegian, sidePositionNorwegianToDomain
} from "../../../../../sidePositionUtilities";
import {Locational} from "../../../../../integration/representation/feature";

interface CellState {
}

interface TagProps {
    hasFocus: boolean;
    feature: DisplayFeature;
    loading: boolean;
}

interface DispatchProps {
    updateSidePosition: UpdateSidePositions;
}

interface StateProps {
    showEditor: boolean;
    sidePositionIsAllowed: boolean,
}

type Props = TagProps & StateProps & DispatchProps;

class SidePositionCell extends React.Component<Props, CellState> {

    render() {
        let {hasFocus, feature, updateSidePosition, sidePositionIsAllowed, loading} = this.props;

        let disabled: boolean = !feature.locational || !sidePositionIsAllowed;
        let cellValueClasses = classNames({
            'cell-component': true,
            'cell-focus': hasFocus,
            'disabled': disabled,
            'edited': feature.locational ? feature.locational.sidePositionEdited : false
        });

        const domainSidePositionMeteringDirection = getSidePositionForFeatureRelativeToMeteringDirection(feature);
        const norwegianSidePositionMeteringDirection = sidePositionFromDomain(domainSidePositionMeteringDirection);

        let tooltip = !feature.locational ? "Vegobjektet mangler stedfesting" : !sidePositionIsAllowed ? "Denne typen kan ikke ha sideposisjon": "";

        const editor = this.props.hasFocus && this.props.showEditor ?
            <SidePositionEditor
                feature={feature}
                doUpdateSidePosition={updateSidePosition}
            /> : null;

        if(loading){
            return <div className={'cssloader small'}/> ;
        }


        return (
            <div className={cellValueClasses} title={tooltip}>
                {editor || norwegianSidePositionMeteringDirection}
            </div>
        );
    }

}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        showEditor: selectors.showEditor(state),
        sidePositionIsAllowed: selectors.sidePositionIsAllowed(state),
    }
};

const mapDispatchToProps: DispatchProps = ({
    updateSidePosition: updateSidePositions
});

export default connect(mapStateToProps, mapDispatchToProps)(SidePositionCell);



interface DropDownEditorProps {
    doUpdateSidePosition: UpdateSidePositions;
    feature: DisplayFeature;
}

interface DropDownEditorState {
    options: string[];
}


class SidePositionEditor extends React.Component<DropDownEditorProps, DropDownEditorState> {

    private inputElement: HTMLSelectElement;

    constructor(props: DropDownEditorProps){
        super(props);
        this.state = {options: getSidePositionsNorwegian()}
    }

    render() {

        let {feature} = this.props;

        const domainSidePositionMeteringDirection = getSidePositionRelativeToMeteringDirection(feature.locational.locationals[0]);
        const norwegianSidePositionMeteringDirection = sidePositionFromDomain(domainSidePositionMeteringDirection);
        return (
            <span>
                <select value={norwegianSidePositionMeteringDirection}
                        onChange={(e) => this.handleValueChange(e)}
                        ref={(elm) => this.inputElement = elm}
                >
                    <option key={"novalue"} value={null}> </option>
                    {this.state.options.map(option => <option key={option} value={option}>{option}</option>)}
                </select>
            </span>
        )

    }

    componentDidMount(): void {
        this.inputElement.focus();
    }

    handleValueChange = function (event: React.ChangeEvent<HTMLSelectElement>) {
        let {feature, doUpdateSidePosition} = this.props;
        const selectedSidePositionRelativeToMeteringDirection = sidePositionNorwegianToDomain(event.target.value);
        const sidePositionEdits: SidePositionEdit[] = [];
        feature.locational.locationals.forEach((locational: Locational) => {
            const sidePositionEdit = createSidePositionEdit(locational, selectedSidePositionRelativeToMeteringDirection, feature);
            sidePositionEdits.push(sidePositionEdit);
        });
        doUpdateSidePosition(sidePositionEdits);
    }
}
